import Chart from "react-apexcharts";

const DemographicsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="text-center text-muted">No data available</div>;
  }

  const labels = { M: 'Male', F: 'Female' };
  const colors = { M: '#0d6efd', F: '#e91e63' };

  const chartData = {
    series: data.map(item => item.COUNT),
    options: {
      chart: {
        type: 'donut'
      },
      labels: data.map(item => labels[item.GENDER] || item.GENDER),
      colors: data.map(item => colors[item.GENDER] || '#6c757d'),
      legend: {
        position: 'bottom'
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val.toFixed(1)}%`
      },
      tooltip: {
        y: {
          formatter: (val) => `${val} patients`
        }
      }
    }
  };

  return <Chart options={chartData.options} series={chartData.series} type="donut" height={300} />;
};

export default DemographicsChart;